/**
 * Using window in Next.js is a bit tricky, as it's not available during SSR.
 * This hook provides a way to access the window object in a safe way.
 */
export const windowIfAvailable =
  // eslint-disable-next-line no-restricted-globals
  typeof window !== "undefined" ? window : undefined;
